







// import router from '@/router';
import { ProfileModule } from "@/store";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import RemainingBalance from "./RemainingBalance.vue";

@Component({
  components: {
    RemainingBalance
  }
})
export default class RemainingBalanceUA extends Vue {
  public profileStore: ProfileModule = getModule(ProfileModule, this.$store);

  // get organizationId(): string | undefined {
  //   if (typeof this.$route.query.oid !== 'string') return undefined;
  //   return this.$route.query.oid;
  // }

  public isLoading: boolean = true;
  public organizationId: string | undefined;

  get userId(): string | null {
    if (typeof this.$route.query.uid !== 'string') return null;
    return this.$route.query.uid;
  }

  async mounted() {
    let organization = await this.profileStore.fetchOrganizationsByDomainUrl().catch();
    if (organization && organization !== undefined) {
      this.organizationId = organization.organizationId;
    }
    this.isLoading = false;
  }
}

